<div class="d-flex justify-content-center">
  <ng-container *ngIf="isActive !== null ; else nullTemplate">
    <rx-icon
      [name]="isActive ? 'checkmark' : 'close'"
      [stroke]="isActive ? 'primary-darker': 'red-dark'"
      size="lg"
      [fill]="isActive ? 'none' : 'red-dark'"
      [attr.data-qa]="testId + (isActive ? '-check-icon' : '-cross-icon')"
    />
  </ng-container>
  <ng-template #nullTemplate>
    <span [attr.data-qa]="testId + '-none'">-</span>
  </ng-template>
</div>

